/*
 *   File : manage-product.js
 *   Author : https://evoqins.com
 *   Description : manage product file
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useRef, useState } from 'react';

//styles
import styles from "../../../Style/Component/input.module.scss";

//Custom components
import { Icon } from '../../../Component/Icon';
import { DownloadButton, PrimaryButton, TextButton } from '../../../Component/Buttons';
import { DataTableComponent } from '../../../Component/DataTable';
import { ConfirmDeleteModal, ManageProductModal } from "../../../Component/Modal";
import { Modal } from 'bootstrap';
import { APIService } from '../../../Service';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader } from '../../../Component/Others';
import { EmptyScreen } from '../../../Component/EmptyComponent';

import { PreviewSalesBill } from '../../../Component/Modal';
import { toast } from 'react-toastify';
import { CustomSearchInput, CustomSelectBox } from '../../../Component/FormElements';


const ROWS_PER_PAGE = 20;

const PRODUCT_SORT_FIELDS = [
    'product_code',
    'name',
    'type',
    'category',
    'innovation',
    'finish',
    'points',
    'size',
];

const ManageProduct = () => {

    const { state } = useLocation();
    const navigate = useNavigate();
    const isSortingRef = useRef(false);
    const skipListFetchRef = useRef(false);

    const [toggle, setToggle] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [uploadModal, setUploadModal] = useState(false);

    const [deleteId, setDeleteId] = useState(null);
    const [deleteResponse, setDeleteResponse] = useState(false);

    const [productList, setProductList] = useState({});
    const [loader, setLoader] = useState(true);
    const [editProductModal, setEditProductModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);

    const [selectedDocument, setSelectedDocument] = useState("https://jotun-dev.s3.ap-south-1.amazonaws.com/public/admin/master/course-image-156x140.jpg");

    const [editStatus, setEditStatus] = useState(false);
    const [modalBtnLoader, setModalBtnLoader] = useState(false);
    const [editData, setEditData] = useState({});
    const [downloadLoader, setDownloadLoader] = useState(false);

    const [toggleFilter, setToggleFilter] = useState(false);

    const [selectedFinish, setSelectedFinish] = useState(null);
    const [selectedInterior, setSelectedInterior] = useState(null);

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedInnovation, setSelectedInnovation] = useState(null);


    const [searchValue, setSearchValue] = useState("");

    const [uploadResponse, setUploadResponse] = useState(false);
    const [filterData, setFilterData] = useState({});
    const [clearFilter, setClearFilter] = useState(false);

    const [sortField, setSortField] = useState(null);
    const [sortDirection, setSortDirection] = useState(null);


    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });

        _getFilterData();
    }, []);

    useEffect(() => {
        if (state !== null) {
            if (state?.current_page) {
                setCurrentPage(state.current_page);
            } else {
                setCurrentPage(1);
            }

            // if (state?.toggle) {
            //     setToggle(state.toggle);
            // } else {
            //     setToggle(false);
            // }
        } else {
            setCurrentPage(1);
            // setToggle(false);
        }
    }, [state]);

    useEffect(() => {
        if (currentPage !== 0) {
            if (skipListFetchRef.current) {
                skipListFetchRef.current = false;
                return;
            }
            _getProductList();
        }
    }, [currentPage, clearFilter, searchValue]);

    useEffect(() => {
        if (uploadModal === true) {
            const upload_modal = new Modal(document.getElementById('upload-product-modal'));
            upload_modal.show();
        }
    }, [uploadModal]);

    useEffect(() => {
        if (editProductModal === true) {
            const edit_modal = new Modal(document.getElementById('upload-product-modal'));
            edit_modal.show();
        }
    }, [editProductModal]);

    useEffect(() => {
        if (previewModal === true) {
            const preview_modal = new Modal(document.getElementById('preview-sale-history-modal'));
            preview_modal.show();
        }
    }, [previewModal]);

    useEffect(() => {
        if (deleteId !== null) {
            const delete_modal = new Modal(document.getElementById('confirm-delete-modal'));
            delete_modal.show();
        }
    }, [deleteId]);

    // handle page change 
    const _handlePageChange = (page_num) => {
        // Ignore RDT's automatic page reset while we handle sort ourselves
        if (isSortingRef.current) {
            isSortingRef.current = false;
            return;
        }

        if (page_num === currentPage) {
            return;
        }

        navigate(window.location.pathname, {
            state: {
                current_page: page_num
            }
        });

        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    };

    const _handleSort = (column, direction) => {
        const sortBy = column.sortField || column.id || null;

        if (!sortBy || !PRODUCT_SORT_FIELDS.includes(sortBy)) {
            return;
        }

        isSortingRef.current = true;
        setSortField(sortBy);
        setSortDirection(direction);
        setLoader(true);

        // Only skip the list useEffect when page will actually change.
        // If already on page 1, useEffect won't run and a stuck skip flag
        // would block the next pagination API call (loader stuck).
        if (currentPage !== 1) {
            skipListFetchRef.current = true;
        }
        setCurrentPage(1);
        navigate(window.location.pathname, {
            state: {
                current_page: 1
            }
        });
        _getProductList(1, sortBy, direction);

        setTimeout(() => {
            isSortingRef.current = false;
        }, 0);
    };

    const _handleClearAll = () => {

        setSelectedInterior(filterData.category_id[0])
        setSelectedCategory(filterData.category_name[0])
        setSelectedFinish(filterData.type[0])
        setSelectedInnovation(filterData.innovation[0])


        setClearFilter(true);
        setCurrentPage(1);
        setSortField(null);
        setSortDirection(null);
    };

    const TABLE_COLUMN = [
        {
            name: 'Product code',
            id: 'product_code',
            sortField: 'product_code',
            selector: row => row.item_code,
            width: '180px',
            sortable: true
        },
        {
            name: 'Product name',
            id: 'name',
            sortField: 'name',
            selector: row => row.name,
            cell: row =>
                <div className='d-flex gap-1 align-items-center'>
                    <p className='mb-0'>
                        {row.name}
                    </p>
                    {/* <div className={` e-bg-apple d-flex align-items-center justify-content-center e-text-white e-alt-font-noto-sans  e-font-10 e-font-weight-400 line-height-12px rounded-circle `} style={{ width: "8px", height: "8px" }}>

                    </div> */}
                </div>,
            width: '320px',
            sortable: true
        },
        {
            name: 'Type',
            id: 'type',
            sortField: 'type',
            selector: row => row.interior_exterior || "-",
            width: '120px',
            sortable: true
        },
        {
            name: 'Category',
            id: 'category',
            sortField: 'category',
            selector: row => row.category || "-",
            width: '120px',
            sortable: true
        },
        {
            name: 'Innovation/Old',
            id: 'innovation',
            sortField: 'innovation',
            selector: row => row.innovation === "nan" ? "-" : row.innovation || "-",
            width: '140px',
            sortable: true
        },
        {
            name: 'Finish',
            id: 'finish',
            sortField: 'finish',
            selector: row => row.type || "-",
            width: '110px',
            sortable: true
        },
        {
            name: 'Points',
            id: 'points',
            sortField: 'points',
            selector: row => row.points || "-",
            width: '100px',
            sortable: true
        },
        {
            name: 'Size',
            id: 'size',
            sortField: 'size',
            selector: row => row.size || "-",
            cell: row => <>{row.size_text || "-"}</>,
            width: '130px',
            sortable: true
        },
        // {
        //     name: 'Action',
        //     cell: row =>
        //         <div className='d-flex align-items-center gap-5'>
        //             <TextButton name="Edit" onPress={() => {
        //                 setEditProductModal(true);
        //                 setEditData(row);
        //             }} />
        //             <TextButton name="Delete"
        //                 className="e-text-lust"
        //                 onPress={() => setDeleteId(row.id)} />
        //         </div>,
        //     width: '150px',
        // },
    ];


    // API - Get Filter data
    const _getFilterData = () => {
        let is_post = false;
        let url = 'product/filter-data';
        let data = {};

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setFilterData(response.data);

                setSelectedInterior(response.data.category_id[0])
                setSelectedCategory(response.data.category_name[0])
                setSelectedFinish(response.data.type[0])
                setSelectedInnovation(response.data.innovation[0])
            } else {
            }
        });
    };

    // API - get product list
    const _getProductList = (page_num = currentPage, sort_by = sortField, sort_order = sortDirection) => {
        setLoader(true);
        let is_post = true;
        let url = 'product/ocr_product/list';
        let data = {
            // "points": !toggle,
            "query": searchValue,
            "page_num": page_num,
            "limit": ROWS_PER_PAGE,

            "type": selectedFinish?.value || null,
            "category_id": selectedInterior?.value || null,
            "category_name": selectedCategory?.value || null,
            "innovation": selectedInnovation?.value || null,
            "sort_by": sort_by ? [sort_by] : null,
            "order": sort_order ? [sort_order] : null
        };
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setProductList(response.data);
            } else {
                setProductList({ data: [] });
            }
            setLoader(false);
            setClearFilter(false);

            window.scrollTo({
                top: 0, behavior: 'smooth'
            });
        });
    };

    // API - Edit product
    const _editProduct = (request) => {
        setModalBtnLoader(true);
        let is_post = true;
        let url = 'product/ocr_product/edit';
        let data = {
            "product_id": request.product_id,
            "name": request.product_name,
            "item_code": request.product_code,
            "points": request.product_point,
            "category_id": request.product_category,


            "category": request.category,
            "type": request.type,
            "innovation": request.innovation,
            "size": Number(request.size),
            "size_text": `${Number(request.size)}L`
        };
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setEditStatus(true);
            } else {
                setEditStatus(false);
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setModalBtnLoader(false);
        });
    };


    // API - Download list
    const _download = () => {
        setDownloadLoader(true);
        let is_post = true;
        let url = 'product/ocr_product/download';
        let data = {
            "type": selectedFinish?.value || null,
            "category_id": selectedInterior?.value || null,
            "category_name": selectedCategory?.value || null,
            "innovation": selectedInnovation?.value || null
        };
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                if (productList?.data?.length !== 0) {
                    const link = document.createElement('a');
                    link.href = response.file_url;
                    link.download = "product_list";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    toast.dismiss();
                    toast.error(response.message, {
                        type: "error",
                        className: "e-toast",
                    });
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setDownloadLoader(false);
        });
    };

    // API - Delete product
    const _deleteProduct = (id) => {
        setModalBtnLoader(true);
        let is_post = true;
        let url = 'product/ocr_product/delete';
        let data = {
            "product_id": id
        };
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setDeleteResponse(true);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setModalBtnLoader(false);
        });
    };


    // API - Upload 
    const _uploadProduct = (file) => {
        setModalBtnLoader(true);
        let is_post = true;
        let url = 'product/ocr_product/upload';
        let data = {
            "file": file
        };
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setUploadResponse(true);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setModalBtnLoader(false);
        });
    };


    return (
        <section className='pb-5 '>
            <div className='e-bg-lavender-blush-light padding-12px-top padding-98px-bottom padding-52px-lr'>
                <div className='d-flex align-items-center gap-2 justify-content-between'>
                    <h1 className='mb-0 e-primary-font-playfair e-font-24 line-height-32px e-text-rich-black e-font-weight-600'>
                        Manage Products
                    </h1>
                    <div className='position-relative'>
                        <img src={require("../../../Assets/Image/upload.svg").default}
                            draggable={false}
                            className='position-absolute left-16px top-8px d-flex'
                            alt='upload' />
                        <PrimaryButton name="Upload master sheet"
                            className="w-202px py-2 e-border-radius-16 px-3 text-end"
                            onPress={() => setUploadModal(true)} />
                    </div>
                </div>
            </div>
            <div className='margin-neg-66px-top padding-52px-lr'>
                <div className='e-bg-white e-border-1px-platinum-dark e-admin-box-shadow py-4 e-border-radius-16'>
                    <div className='px-3'>
                        <div className='pb-4 d-flex align-items-center justify-content-between'>
                            <h4 className='mb-0 e-text-rich-black e-alt-font-noto-sans e-font-18 e-font-weight-500 line-height-28px'>
                                Products list
                            </h4>
                            {/* <div className='e-display-flex justify-content-space-between '>
                                <p className='pe-2 mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-16 e-font-weight-400 line-height-24px'>
                                    Show products without points
                                </p>
                                <label className={`${styles.e_resource} `} >
                                    <input type="checkbox"
                                        checked={toggle}
                                        onChange={_handleToggle} />
                                    <span className={`${styles.e_slider}`}></span>
                                </label>
                            </div> */}

                            <div className={`d-flex align-items-center gap-3`}>
                                {/* <div className={`${productList?.data?.length === 0 ? "pe-none opacity-50 user-selection-none" : ""}  `}>
                                    <div className={`${downloadLoader ? "pe-none" : ""} d-flex align-items-center text-decoration-hover-underline cursor-pointer `}
                                        onClick={() => {
                                            // setPreviewModal(true);
                                            _download();
                                        }}>
                                        {downloadLoader ?
                                            <div class="liquid-loader me-5 pe-4 opacity-9">
                                                <div class="loading-text e-text-indigo e-alt-font-noto-sans e-font-16 e-font-weight-500 line-height-24px">
                                                    Loading<span class="dot">.</span><span class="dot">.</span
                                                    ><span class="dot">.</span>
                                                </div>
                                            </div>
                                            :
                                            <>
                                                <p className='mb-0 e-text-indigo e-alt-font-noto-sans e-font-16 e-font-weight-500 line-height-24px'>
                                                    Download Current .xl file
                                                </p>
                                                <Icon icon="download-icon" size={24} />
                                            </>
                                        }
                                    </div>
                                </div> */}

                                <DownloadButton loader={downloadLoader}
                                    disabled={productList?.data?.length === 0}
                                    onClick={_download} />

                                <CustomSearchInput placeholder={"Search by product name or code"}
                                    type="text"
                                    require
                                    value={searchValue}
                                    className="w-320px padding-8px-tb py-2 "
                                    labelStyle="e-font-weight-500"
                                    iconClass="top-10px"
                                    handleChange={(e) => setSearchValue(e)}
                                    handleClear={() => { setSearchValue("") }} />


                                <div>
                                    <img src={toggleFilter ? require("../../../Assets/Image/filter-icon-white.svg").default : require("../../../Assets/Image/filter-icon.svg").default}
                                        draggable={false}
                                        className={` ${toggleFilter ? `e-bg-indigo` : ``} transition e-border-1px-anti-flash-white e-border-radius-8 p-2 cursor-pointer`}
                                        alt='filter'
                                        onClick={() => setToggleFilter(!toggleFilter)} />
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* filter */}
                    {toggleFilter &&
                        <div className='e-bg-anti-flash-white-dark py-3 px-4 mb-3'>
                            <div className='row'>

                                {/* City filter */}
                                <div className='col-md-3 col-sm-4 col-4'>
                                    <CustomSelectBox label="Interior/Exterior"
                                        value={selectedInterior}
                                        options={filterData.category_id}
                                        type={2}
                                        optional={true}
                                        className="e-bg-white e-border-radius-4 e-table-select"
                                        minHeight="34px"
                                        padding="0 8px"
                                        labelClass="e-font-weight-600"
                                        wrapperHeight="0px"
                                        isSearchable={false}
                                        selectChange={(value) => setSelectedInterior(value)}
                                    />
                                </div>
                                <div className='col-md-3 col-sm-4 col-4'>
                                    <CustomSelectBox label="Category"
                                        value={selectedCategory}
                                        options={filterData.category_name}
                                        type={2}
                                        optional={true}
                                        className="e-bg-white e-border-radius-4 e-table-select"
                                        minHeight="34px"
                                        padding="0 8px"
                                        labelClass="e-font-weight-600"
                                        wrapperHeight="0px"
                                        isSearchable={false}
                                        selectChange={(value) => setSelectedCategory(value)}
                                    />
                                </div>
                                <div className='col-md-3 col-sm-4 col-4'>
                                    <CustomSelectBox label="Innovation/Old"
                                        value={selectedInnovation}
                                        options={filterData.innovation}
                                        type={2}
                                        optional={true}
                                        className="e-bg-white e-border-radius-4 e-table-select"
                                        minHeight="34px"
                                        padding="0 8px"
                                        labelClass="e-font-weight-600"
                                        wrapperHeight="0px"
                                        isSearchable={false}
                                        selectChange={(value) => setSelectedInnovation(value)}
                                    />
                                </div>

                                <div className='col-md-3 col-sm-4 col-4'>
                                    <CustomSelectBox label="Finish"
                                        value={selectedFinish}
                                        options={filterData.type}
                                        type={2}
                                        optional={true}
                                        className="e-bg-white e-border-radius-4 e-table-select"
                                        minHeight="34px"
                                        padding="0 8px"
                                        labelClass="e-font-weight-600"
                                        wrapperHeight="0px"
                                        isSearchable={false}
                                        selectChange={(value) => setSelectedFinish(value)}
                                    />
                                </div>

                                <div className='pt-3 d-flex align-items-center gap-3 justify-content-end'>
                                    <TextButton name="Clear all"
                                        onPress={_handleClearAll} />
                                    {/* <PrimaryButton name="Filter now"
                                        className={` py-2 e-border-radius-8`}
                                        onPress={() => { _getProductList() }} /> */}
                                    <PrimaryButton name="Filter now"
                                        className="px-3 py-1 e-border-radius-8"
                                        onPress={() => {
                                            _getProductList(1);
                                            navigate(window.location.pathname, {
                                                state: {
                                                    current_page: 1
                                                }
                                            });
                                        }
                                        } />
                                </div>
                            </div>
                        </div>
                    }

                    {loader ?
                        <Loader />
                        :
                        <>
                            {productList.data.length !== 0 ?
                                <div className={`e-table no-strip no-hover`}>
                                    <DataTableComponent
                                        key={`product-table-${currentPage}-${sortField || 'none'}-${sortDirection || 'none'}`}
                                        columns={TABLE_COLUMN}
                                        data={productList.data}
                                        pagination={true}
                                        paginationServer={true}
                                        paginationPerPage={ROWS_PER_PAGE}
                                        paginationTotalRows={productList.total_count}
                                        paginationDefaultPage={currentPage}
                                        paginationResetDefaultPage={false}
                                        sortServer={true}
                                        defaultSortFieldId={sortField}
                                        defaultSortAsc={sortDirection !== 'desc'}
                                        onSort={_handleSort}
                                        onChangePage={_handlePageChange} />
                                </div>
                                :
                                // empty screen
                                <div className='py-5 my-5'>
                                    <EmptyScreen message="No products found" />
                                </div>
                            }

                        </>
                    }

                </div>
            </div>

            {uploadModal === true &&
                <ManageProductModal type={1}
                    title="Upload"
                    description="Select and upload the required file to proceed."
                    buttonLabel="Upload"
                    status={uploadResponse}
                    loader={modalBtnLoader}
                    handleClose={() => {
                        setTimeout(() => {
                            setUploadModal(false);
                            setUploadResponse(false);
                        }, 200);
                    }}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setUploadModal(false);
                            setUploadResponse(false);
                            _getProductList(1);
                            navigate(window.location.pathname, {
                                state: {
                                    current_page: 1
                                }
                            });
                        }, 200);

                        toast.dismiss();
                        toast.success("Successfully uploaded products", {
                            type: "success",
                            className: "e-toast",
                        });
                    }}
                    handleSubmit={_uploadProduct}
                />
            }

            {editProductModal === true &&
                <ManageProductModal type={2}
                    title="Edit Product"
                    description="Update product details and adjust reward points with ease."
                    buttonLabel="Update"
                    editData={editData}
                    status={editStatus}
                    loader={modalBtnLoader}
                    categoryData={filterData.category}
                    handleClose={() => {
                        setTimeout(() => {
                            setEditProductModal(false);
                            setEditData({});
                            setEditStatus(false);
                        }, 200);
                    }}

                    handleSuccess={() => {
                        setTimeout(() => {
                            setEditProductModal(false);
                            setEditData({});
                            _getProductList(1);
                            navigate(window.location.pathname, {
                                state: {
                                    current_page: 1
                                }
                            });
                            setEditStatus(false);
                        }, 200);
                        toast.dismiss();
                        toast.success("Successfully updated product", {
                            type: "success",
                            className: "e-toast",
                        });
                    }}
                    handleSubmit={_editProduct}
                />
            }

            {/* confirm delete modal */}
            {deleteId !== null &&
                <ConfirmDeleteModal label="product"
                    deleteId={deleteId}
                    response={deleteResponse}
                    loader={modalBtnLoader}
                    delete={(id) => _deleteProduct(id)}
                    handleClose={() => setDeleteId(null)}
                    success={() => {
                        setDeleteResponse(false);
                        _getProductList(1);
                        navigate(window.location.pathname, {
                            state: {
                                current_page: 1
                            }
                        });
                    }} />
            }

            {previewModal === true &&
                <PreviewSalesBill file={selectedDocument}
                    handleClose={() => {
                        setPreviewModal(false);
                        setSelectedDocument({});
                    }} />
            }
        </section>
    )
}

export default ManageProduct;
